import styled from 'styled-components';
import { prem } from 'styles/helpers/spacing';
import { BODY, HEADLINE } from 'styles/helpers/typography';
import { BREAKPOINTS } from 'styles/constants/devices';
import { IonButtonWrapper } from 'components/common/button/Button.styled';

const EndScreenWrapper = styled.div`
  text-align: center;
  padding: ${prem(20)} 0 ${prem(20)};

  .pix-wrapper {
    margin-bottom: ${prem(16)};

    svg {
      width: 100%;
      max-width: ${prem(70)};
    }
  }

  h3 {
    ${HEADLINE.small};
    margin-bottom: ${prem(16)};
  }

  p {
    color: var(--ion-text-color-secondary);
    ${BODY.large};
    text-align: left;
    max-width: ${prem(700)};
    margin: 0 auto ${prem(16)};

    @media (${BREAKPOINTS.M}) {
      text-align: center;
    }
  }

  .install-intro {
    color: var(--ion-text-color);
    font-weight: bold;
    margin-bottom: ${prem(24)};
  }

  ${IonButtonWrapper} {
    max-width: ${prem(700)};
    margin: 0 auto;
  }
`;

export { EndScreenWrapper };
